import { greetingReferencesAdapter } from '../agent-settings/adapters';
import { DEFAULT_AGENT_SETTINGS_LANGUAGE_CODE } from '../agent-settings/constants';
import { DEFAULT_AZURE_CONFIG } from '../content-filter-settings';
import type { ChannelConfig } from './types';

export const CHANNELS_SLICE_NAME = 'channels';

export const createDefaultChannelConfig = (): ChannelConfig => ({
  llmSettings: {
    modelId: '',
    temperature: undefined,
    updatedAt: '',
    updatedBy: '',
  },
  stylePrompt: {
    prompt: '',
    createdAt: '',
    createdBy: '',
    updatedAt: '',
    updatedBy: '',
  },
  greeting: {
    welcomeMessage: '',
    createdAt: '',
    createdBy: '',
    updatedAt: '',
    updatedBy: '',
    references: greetingReferencesAdapter.createInitialState(),
    languageCode: DEFAULT_AGENT_SETTINGS_LANGUAGE_CODE,
  },
  safetyFilters: {
    type: 'azure',
    azureConfig: DEFAULT_AZURE_CONFIG,
    disabled: true,
    updatedAt: '',
    updatedBy: '',
  },
});
